export default __webpack_public_path__ + "static/1842-c957363ae23ddbe329afbfdd23a0c936.gif";